<template>
    <v-card class="pa-5 margin-bottom">
        <h4>Filter</h4>
        <v-row class="mx-2 mt-3">
            <v-col cols="3">
                <v-select
                    :items="years"
                    label="Years"
                    item-text="value"
                    item-value="id"
                    v-model.trim="filter.years"
                    multiple
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0">{{ item.value }} </span>
                        <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                        > (+ {{ filter.years.length - 1 }} others)</span>
                    </template>
                </v-select>
            </v-col>
        </v-row>
        <v-row class="mx-2 mt-0 pt-0">
            <v-col cols="12" class="text-center mt-0 pt-0">
                <v-btn class="mt-4 generate-btn-margin" small color="success"
                       @click="handleGenerateClick">Generate current data
                </v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'DataAnalyticsAf0GenerateCard',
    data() {
        return {
            filter: {
                years: [new Date().getFullYear()],
            },
            years: [],
        };
    },
    mounted() {
        const startYear = 2022;
        const currentYear = new Date().getFullYear();
        this.years = Array.from(
            {length: currentYear - startYear + 1},
            (_, i) => ({id: startYear + i, value: startYear + i}),
        );
    },
    methods: {
        ...mapActions('analytics', ['generateCsvFile', 'getAnalyticsAf0DataTableData']),
        async handleGenerateClick() {
            await this.generateCsvFile({type: 'af0', filters: this.filter});
            await this.getAnalyticsAf0DataTableData();
        },
    },
};
</script>

<style scoped>

</style>